import { UseAppFormProps } from "hooks/useAppForm";
import React from "react";
import { FormValueProps } from ".";
import useAppSelector from "hooks/useAppSelector";

interface SidebarProps {
    form: UseAppFormProps<FormValueProps>;
}

const defaultValue = {
    date: undefined,
    description: undefined,
    email: undefined,
    fullName: undefined,
    specialtyId: undefined,
    timeFrameId: undefined,
    userId: undefined,
    method: "Lấy vé tại quầy"
}
export const Sidebar: React.FC<SidebarProps> = ({ form }) => {
    const { specialty, user, timeFrame } = useAppSelector((state) => state);

    const _specialty = specialty.list.options.find((item) => item.id === form.values.specialtyId);
    const _user = user.list.options.find((item) => item.id === form.values.userId);
    const _timeFrame = timeFrame.list.options.find((item) => item.id === form.values.timeFrameId);
    const steps = [
        {
            title: "Chuyên khoa",
            value: _specialty?.name || "Hãy chọn chuyên khoa ở bảng dữ liệu",
            show: true,
            iconClass: "fa-solid fa-hospital-user",
            onClick: () => {
                form.handleChange({
                    ...defaultValue
                })
            }
        },
        {
            title: "Bác sĩ",
            value: _user ? `${_user.firstName} ${_user.lastName}` : form.values.userId === -1 ? "Tuỳ chọn bác sĩ" : "Hãy chọn bác sĩ ở bảng dữ liệu",
            show: Boolean(form.values.specialtyId),
            iconClass: "fa-solid fa-user-doctor",
            onClick: () => {
                form.handleChange({
                    ...defaultValue,
                    specialtyId: form.values.specialtyId
                })
            }
        },
        {
            title: "Hình thức",
            value: form.values.method,
            show: Boolean(form.values.userId),
            iconClass: "fa-solid fa-square-check",
            onClick: () => {
                form.handleChange({
                    ...defaultValue,
                    specialtyId: form.values.specialtyId,
                    userId: form.values.userId
                })
            }
        },
        {
            title: "Thời gian",
            value: form.values.date && Boolean(form.values.timeFrameId) ? `${form.values.date} ${_timeFrame?.name || ""}` : "Hãy chọn thời gian ở bảng dữ liệu",
            show: Boolean(form.values.userId),
            iconClass: "fa-solid fa-clock",
            onClick: () => {
                form.handleChange({
                    ...defaultValue,
                    specialtyId: form.values.specialtyId,
                    userId: form.values.userId
                })
            }
        },
        {
            title: "Thông tin liên hệ",
            value: !form.values.fullName && !form.values.email ? "Nhập thông tin liên hệ vào form" : `${form.values.fullName || ""} - ${form.values.email || ""}`,
            show: Boolean(form.values.date) && Boolean(form.values.timeFrameId),
            iconClass: "fa-solid fa-info"
        }
    ];

    return (
        <div className="w-full md:w-1/4 bg-white shadow rounded p-4">
            <h2 className="text-lg font-bold mb-4">THÔNG TIN ĐẶT HẸN</h2>
            <div className="relative space-y-6">
                <div className="absolute left-5 top-0 bottom-0 w-0.5 border-l-2 border-dashed border-gray-300"></div>
                {steps
                    .filter((item) => item.show)
                    .map((s, i, arr) => (
                        <div key={i} className="relative flex items-start space-x-3 mb-2">
                            <div
                                className="z-10 w-10 h-10 flex items-center justify-center rounded-full bg-blue-50 text-blue-600 shadow cursor-pointer"
                                onClick={s.onClick}
                            >
                                <i className={s.iconClass} />
                            </div>
                            <div className="flex-1">
                                <p className="font-medium mb-1">{s.title}</p>
                                <p className="text-sm text-gray-500">{s.value || `Chưa chọn`}</p>
                            </div>
                        </div>
                    ))}
            </div>
        </div>
    );
};
